var render = function render(){var _vm=this,_c=_vm._self._c;return _c('terms-of-service')
}
var staticRenderFns = []

export { render, staticRenderFns }